import { ButtonProps } from '@mui/material';
import React from 'react';
import SecondaryButton from './SecondaryButton';
import { ArrowForwardIos } from '@mui/icons-material';
import '../ButtonStyle.scss';

function SecondaryButtonWithMenuArrow(
    props: Omit<ButtonProps, 'variant' | 'endIcon'>
): React.ReactElement {
    return (
        <SecondaryButton
            {...props}
            classes={{
                endIcon: 'buttonArrowRightAlign',
            }}
            endIcon={
                <ArrowForwardIos
                    className={
                        props.disabled ? `forwardIcon disabled` : 'forwardIcon'
                    }
                />
            }
        />
    );
}

export default SecondaryButtonWithMenuArrow;
